import React from "react";
import Header from "../components/developer_header.jsx"; 
import Footer from "../components/developer_footer.jsx";

const DeveloperPrivacyLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 flex-grow">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6 sm:mb-8 text-center">Privacy Policy</h1>
        
        <div className="bg-white rounded-lg shadow-md p-5 sm:p-8">
          <div className="text-sm sm:text-base text-gray-700 leading-relaxed space-y-4 sm:space-y-6 text-left">
            <p>
              1. Our Social Missions empower social mobility through Open API Pass technology enablers governed by Public-Private-Community Ecosystem Frameworks.
            </p>
            
            <p>
              2. We may use "cookies", where a small data file is sent to your browser to store and track information about you when you enter our digital service. The cookie is used to track information such as the number of users and their frequency of use, profiles of users and their preferred digital services. While this cookie can tell us when you enter our digital services and which pages you visit, it cannot read data off your hard disk.
            </p>
            
            <p>
              3. You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the digital service.
            </p>
            
            <p>
              4. If you provide us with personally identifiable data:
              <ul className="list-none pl-4 mt-2 space-y-2">
                <li className="flex">
                  <span className="mr-2">a.</span>
                  <span>Your Personal Data will be primarily used for the provisioning of goods and services to you.</span>
                </li>
                <li className="flex">
                  <span className="mr-2">b.</span>
                  <span>Where appropriate, with your permission, we may share necessary data with Government agencies, or Community partners, or Institutions of Higher Learning, or Goods and Services providers so as to serve you in the most efficient and effective way unless such sharing is prohibited by law.</span>
                </li>
                <li className="flex">
                  <span className="mr-2">c.</span>
                  <span>We will NOT share your Personal Data except where such entities have been authorised by you to carry out specific services.</span>
                </li>
                <li className="flex">
                  <span className="mr-2">d.</span>
                  <span>For your convenience, we may also display to you data you had previously supplied us. This will speed up the transaction and save you the trouble of repeating previous submissions. Should the data be out-of-date, please supply us the latest data.</span>
                </li>
              </ul>
            </p>
            
            <p>
              5. To safeguard your Personal Data, all electronic storage and transmission of Personal Data is secured with appropriate security technologies.
            </p>
            
            <p>
              6. Our digital services and websites may contain links to other organisation digital services whose data protection and privacy practices may differ from ours. We are not responsible for the content and privacy practices of these other digital services and encourage you to consult the privacy notices of those digital services.
            </p>
            
            <p>
              7. Please contact us at <a href="mailto:community@codeforeword.org" className="text-blue-600 hover:underline">community@codeforeword.org</a> if you:
              <ul className="list-none pl-4 mt-2 space-y-2">
                <li className="flex">
                  <span className="mr-2">a.</span>
                  <span>have any enquires or feedback on our data protection policies and procedures; or</span>
                </li>
                <li className="flex">
                  <span className="mr-2">b.</span>
                  <span>need more information on or access to data which you have provided to us in the past; or</span>
                </li>
                <li className="flex">
                  <span className="mr-2">c.</span>
                  <span>want to delete your account.</span>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default DeveloperPrivacyLayout;